import React from 'react';
import { PropTypes as RPT } from 'prop-types';
import RadioButton from '../components/RadioButton.react';

const letterIndex = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

const Survey = ({
  answer, position, result, questionId, selectAnswer,
}) => (
  <label className="option-list__item" htmlFor={letterIndex[position]}>
    <div className="option-list__control">
      <span className="styled-radio">
        <RadioButton
          name={questionId}
          id={letterIndex[position]}
          checked={position === result - 1}
          onChange={() => { selectAnswer(questionId, answer.value); }}
        />
        <span className="fake-input" />
      </span>
      <strong>{letterIndex[position]}</strong>
    </div>
    <div className="option-list__label">
      {answer.text}
    </div>
  </label>
);

Survey.propTypes = {
  answer: RPT.object,
  position: RPT.number,
  result: RPT.number,
  questionId: RPT.string,
  selectAnswer: RPT.func,
};

export default Survey;
